import { createSelector } from 'reselect'

export const getSpecifications = createSelector(
  (state) => state && state.categories && state.categories.specifications && Array.isArray(state.categories.specifications)
    ? state.categories.specifications : [],
  (specs) => specs
)
